import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function BenefitsSection() {
  return <section className="bg-[#111111] px-5 py-16 md:py-24" data-id="element-1">
      <motion.div className="max-w-3xl mx-auto" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} data-id="element-2">
        <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-10" data-id="element-3">
          Lo que vas a poder hacer después de aplicarlo
        </motion.h2>

        <div className="space-y-6" data-id="element-4">
          <motion.div variants={itemVariants} className="flex items-start gap-4" data-id="element-5">
            <CheckCircleIcon className="w-6 h-6 text-[#E8732A] flex-shrink-0 mt-1" data-id="element-6" />
            <p className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed" data-id="element-7">
              <span className="text-white" data-id="element-8">
                Convertir comentarios tipo "info"
              </span>{' '}
              en conversaciones útiles por DM
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="flex items-start gap-4" data-id="element-9">
            <CheckCircleIcon className="w-6 h-6 text-[#E8732A] flex-shrink-0 mt-1" data-id="element-10" />
            <p className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed" data-id="element-11">
              <span className="text-white" data-id="element-12">Filtrar rápido</span> (sin estar
              horas chateando con curiosos)
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="flex items-start gap-4" data-id="element-13">
            <CheckCircleIcon className="w-6 h-6 text-[#E8732A] flex-shrink-0 mt-1" data-id="element-14" />
            <p className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed" data-id="element-15">
              <span className="text-white" data-id="element-16">
                Enviar el link en el momento correcto
              </span>
              , con la prueba correcta
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="flex items-start gap-4" data-id="element-17">
            <CheckCircleIcon className="w-6 h-6 text-[#E8732A] flex-shrink-0 mt-1" data-id="element-18" />
            <p className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed" data-id="element-19">
              <span className="text-white" data-id="element-20">Dejar de depender</span> de "ojalá el
              próximo video venda"
            </p>
          </motion.div>
        </div>
      </motion.div>
    </section>;
}